import { RouteRecordRaw } from 'vue-router'

import outletRoutes from './outlet/router'
import catalogRoutes from './catalog/router'
import pagesRoutes from './pages/router'
import promoRoutes from './promo/router'
import paymentRoutes from './payment/router'
import notFound from '@/modules/404/router'

const routes: Array<RouteRecordRaw> = [
  ...promoRoutes,
  ...outletRoutes,
  ...catalogRoutes,
  ...pagesRoutes,
  ...paymentRoutes,
  ...notFound,
  {
    path: '/:pathMatch(.*)*',
    redirect: { name: 'not-found' }
  }
]

export default routes
